import axios from 'axios';

const clienteAxios = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://api.appmilam.com',
});

export default clienteAxios;
